import get from "lodash/get";

export const getStoriesFromCollections = (collection, limit) => {
  const items = get(collection, ["items"], []);
  const endLimit = limit || items.length;
  return items
    .slice(0, endLimit)
    .filter((collections) => collections.type === "story")
    .map((item) => item.story);
};

export const getCollectionFromCollections = (collection, limit) => {
  const items = get(collection, ["items"], []);
  const endLimit = limit || items.length;
  return items
    .slice(0, endLimit)
    .filter((collections) => collections.type === "collection")
    .map((item) => item);
};
export const isCollectionEmpty = (collection) => {
  return get(collection, ["items"], []).length === 0;
};
